import { Box, Typography, View } from "components/ui";
import React, { ComponentProps } from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

interface ExtendedBoxProps extends ComponentProps<typeof Box> {
	title?: string;
	customTitle?: () => JSX.Element;
	bg?: string;
}
const TitledContainer = ({ title, sx, customTitle, children, bg = "$neutral25", zIndex, ...props }: ExtendedBoxProps) => {
	const isMobile = useIsMobile();
	return (
		<View
			borderRadius={12}
			backgroundColor={bg}
			sx={{
				shadowColor: "#000",
				shadowOffset: {
					width: 0,
					height: 1,
				},
				shadowOpacity: 0.18,
				shadowRadius: 1.0,
				elevation: 1,
				zIndex: zIndex || 1,
			}}
		>
			<Box {...props} sx={sx} bg="$lighttealxlight" p={isMobile ? 12 : 24} borderTopLeftRadius={12} borderTopRightRadius={12}>
				{customTitle ? (
					customTitle()
				) : (
					<Typography weight="bold" sx={{ fontSize: 18 }}>
						{title}
					</Typography>
				)}
			</Box>
			{children}
		</View>
	);
};

export default TitledContainer;
